import React,{useState, useCallback, useEffect} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom'//yarn add @types/react-router-dom
import {MuiThemeProvider} from '@material-ui/core/styles';
import Main from "./Main";
import Enter from "./Enter";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTint, faHome, faSignOutAlt, faListAlt, faLock, faKey, faHeart, faBookOpen, faUser, faCaretUp, faCaretDown, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import {Theme} from './Theme';
import "./App.scss";

let storageKey = "retroletters";

const App: React.FC = () => {
  const basename = process.env.REACT_APP_BASENAME;

  const [uid,setUid] = useState("");
  const [gid,setGid] = useState("");
  const [loaded,setLoaded] = useState(false);
  library.add(faTint,faHome,faSignOutAlt,faListAlt,faLock,faKey,faHeart,faBookOpen,faUser,faCaretUp,faCaretDown,faTrashAlt,fab);

	const save= (id?:string)=>{
    //console.log("save",id);
    if( id ){
      const json = {
        "uid": id,
      };
      window.localStorage.setItem(storageKey,JSON.stringify(json));
      setUid(id);
    } else {
      window.localStorage.removeItem(storageKey);
      setUid("");
    }
  };

  const clear = ()=>{
    setGid("");
  }
  
	const load=useCallback(()=>{
    const value = window.localStorage.getItem(storageKey);
		if( value ){
			const json = JSON.parse(value);
			if( json.uid && json.uid!=="" ){
				setUid(json.uid);
				return true;
			}
		}
		return false;
  },[]);

  useEffect( ()=>{
    load();
    setLoaded(true);
  },[load]);

  if(!loaded){
    return (null);
  }

  return (
    <BrowserRouter basename={basename}>
      <MuiThemeProvider theme={Theme}>
      <div className="App">
        <Switch>
          <Route exact path='/' render={()=><Main uid={uid} gid={gid} clear={clear} save={save}/>}/>
          <Route exact path='/:gid' render={()=><Enter set={setGid}/>}/>
        </Switch>
      </div>
      </MuiThemeProvider>
    </BrowserRouter>
  );
}

export default App;
